<template>
	<div>
		<div class="violations-switch-row">
			<v-switch v-model="showAllViolations" :label="t('violations.all_violation')" color="primary-green" hide-details class="switch-label-front" />
			<v-tooltip open-delay="500" :max-width="382" :text="toggleInfoText">
				<template #activator="{ props }"><v-icon v-bind="props" size="18" color="blue" class="ml-1"> mdi-information-outline </v-icon> </template>
			</v-tooltip>
		</div>

		<div v-for="(violation, index) in displayedViolations" :key="index" class="preview-item">
			<div @click="selectChangeLog(violation)">
				<div class="preview-item-content">
					<div class="preview-item-header">
						<span class="d-flex align-center mb-1">
							<span class="preview-item-duty">{{ violation.dutyName }}</span>
							<span class="preview-item-dot"></span>
							<span class="preview-item-title">{{ violation.driver }}</span>
						</span>
						<span class="preview-item-chip">{{ t(violation.category) }}</span>
					</div>
					<div class="d-flex align-center">
						<v-icon size="16">mdi-calendar-month</v-icon>
						<span class="preview-item-title ml-1">{{ formatDateUTC(violation.date) }}</span>
					</div>
				</div>
				<div class="preview-item-details">
					<div class="preview-item-message">{{ t(violation.messageKey, violation.messageParams) }}</div>
					<div class="preview-item-meta">{{ violation.rule }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDutyChangePreview } from '@/rennovation/planning-view/composables/useDutyChangePreview';
import { useDateTime } from '../../../../../../../components/composables/useDateTime.js';
import { usePreviewStore } from '@/rennovation/planning-view/store/usePreviewStore';

const { displayedViolations, showAllViolations } = useDutyChangePreview();
const { t } = useI18n();
const { formatDateUTC } = useDateTime();

const toggleInfoText = computed(() => (showAllViolations.value ? t('all_violations_toggle_info_off') : t('all_violations_toggle_info_on')));

const selectChangeLog = (change) => {
	usePreviewStore().selectedChangeLog = change;
	usePreviewStore().cardClicked = true;
};
</script>

<style scoped lang="scss">
.violations-switch-row {
	display: flex;
	align-items: center;
}

.violations-switch-row .v-input {
	flex: 0 0 auto;
}

.preview-item {
	border: 1px solid #e0e0e0;
	padding: 0;
	background-color: #ffffff;
	border-radius: 8px;
	margin-bottom: 12px;
	cursor: pointer;
}

.preview-item-duty {
	font-family: Roboto;
	font-weight: 700;
	font-size: 16px;
	line-height: 20px;
	letter-spacing: 0.4px;
	vertical-align: bottom;
	color: #000000;
}

.preview-item-title {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #757575;
}

.preview-item-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.preview-item-meta {
	display: flex;
	align-items: center;
	font-family: Roboto;
	font-weight: 400;
	font-size: 12px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #757575;
}

.preview-item-dot {
	width: 3px;
	height: 3px;
	background-color: #bdbdbd;
	border-radius: 4px;
	display: inline-block;
	margin: 0 8px;
}

.preview-item-chip {
	min-width: 46px;
	height: 20px;
	padding: 0 12px;
	border-radius: 10px;
	background-color: #e35056;
	color: #ffffff;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
}

.preview-item-content {
	padding: 10px 12px;
	border-bottom: 1px solid #eeeeee;
}

.preview-item-details {
	display: flex;
	flex-direction: column;
	gap: 4px;
	padding: 10px 12px;
	border-bottom: 1px solid #eeeeee;
}

.preview-item-message {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #616161;
}

.switch-label-front :deep(.v-selection-control) {
	justify-content: flex-start;
	font-size: 14px;
}
</style>
